import { Box, Paper, Skeleton, Stack } from '@mui/material'

/**
 * Loading scaffolds for the per-respondent results (timeline + stats donut).
 * Shown while a respondent / filter / stimulus switch is in flight so the
 * previous respondent's curves don't linger as stale data on screen.
 */

/** Mirrors the {@link EmotionTimeline} chart + legend footprint. */
export function TimelineSkeleton() {
  return (
    <Box>
      <Skeleton variant="rounded" height={220} sx={{ borderRadius: 2 }} />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mt: 0.75 }}>
        {Array.from({ length: 7 }).map((_, i) => (
          <Skeleton key={i} variant="text" width={64} height={16} />
        ))}
      </Box>
    </Box>
  )
}

/** Mirrors the {@link EmotionStatsPanel} layout: title, donut + legend, two tiles. */
export function StatsPanelSkeleton() {
  return (
    <Paper variant="outlined" sx={{ p: 2.25, borderRadius: 3 }}>
      <Stack direction="row" spacing={0.85} alignItems="center">
        <Skeleton variant="circular" width={20} height={20} />
        <Skeleton variant="text" width={140} height={20} />
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 1.5 }}>
        <Skeleton variant="circular" width={132} height={132} sx={{ flexShrink: 0 }} />
        <Stack spacing={0.85} sx={{ flex: 1, minWidth: 0 }}>
          {[0, 1, 2, 3, 4].map((i) => (
            <Stack key={i} direction="row" alignItems="center" spacing={0.85}>
              <Skeleton variant="rounded" width={10} height={10} />
              <Skeleton variant="text" height={14} sx={{ flex: 1 }} />
              <Skeleton variant="text" width={28} height={14} />
            </Stack>
          ))}
        </Stack>
      </Stack>

      <Stack direction="row" spacing={1.25} sx={{ mt: 1.75 }}>
        {[0, 1].map((i) => (
          <Skeleton key={i} variant="rounded" height={96} sx={{ flex: 1, borderRadius: 2 }} />
        ))}
      </Stack>
    </Paper>
  )
}
